import { useEffect } from 'react';

const CreateSlatePage = () => {
  useEffect(() => {
    window && window.location.replace("https://support.slatepages.com/hc/en-us");
  }, []);
  return null;
};

export default CreateSlatePage;